import clsx from "clsx"
import { Filters } from "../../../lib/filters"
import { CompaniesHorizontalFilters } from "../../../lib/filters/accordion/horizontalFiltersCompany"
import { ContactDTO, ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../lib/filters/dto"
import { useAppSelector } from "../../../lib/redux/hooks"
import { ProjectDTO } from "../../projects/dto"
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../projects/mails/dto"
import { ContactsCounterDTO } from "../contacts/dto"
import { TargetListDTO } from "../dto"
import { TargetCompaniesList } from "../editTargetListDetails/companies/list/list"
import { PersonDTO } from "../../database/people/dto"

interface Props {
    toActivate: number
    showPopup: boolean
    setShowPopup: (action: boolean) => void
    selectedIds: { contactId: string, companyId: string }[]
    setSelectedIds: (action: { contactId: string, companyId: string }[]) => void
    filters: FindAllContactsFilters
    setPage: (action: number) => void
    setFilters: (action: Partial<FindAllContactsFilters>) => void
    resetFilters: () => void
    contacts: {
        total: number
        page: number
        perPage: number
        prev: boolean
        next: boolean
        totalPage: number
        data: { company: ContactDTO<ContactType.COMPANY>, employees: PersonDTO[] }[]
    }
    counters: ContactsCounterDTO
    targetList: TargetListDTO
    project: ProjectDTO
    isLoadingEmailsHistory: boolean
    emailsHistory: { messages: EmailsMessagesDTO[] }
    templates: FindAllCustomMailsResponseDTO
}

export function TargetCompaniesBins(props: Props) {
    const { selectedIds, setSelectedIds, setShowPopup, counters, showPopup, setFilters, filters, setPage, resetFilters, contacts, targetList, project, isLoadingEmailsHistory, emailsHistory, templates } = props
    const databaseState = useAppSelector(state => state.database)

    return (
        <div className="max-h-full w-full flex h-full">
            <div className="flex w-full">
                <div
                    className={clsx("transition-all duration-300 w-[20%] h-full opacity-100 rounded-bl-xl", {
                        flex: databaseState.filtersActive,
                        hidden: !databaseState.filtersActive,
                    })}
                >
                    <Filters
                        section="target-bin"
                        contactType={ContactType.COMPANY}
                        isInTargetList
                        resetFilters={function (): void {
                            resetFilters()
                        }}
                        filters={filters}
                        updateFilters={function (newFilters: Partial<FindAllContactsFilters>): void {
                            setFilters(newFilters)
                        }} />
                </div>
                <div
                    className={clsx({
                        "w-full": !databaseState.filtersActive,
                        "w-4/5": databaseState.filtersActive,
                    })}
                >
                    <div className="h-full">
                        <CompaniesHorizontalFilters
                            toActivate={0}
                            onChangeFilters={function (newFilters: Partial<FindAllContactsFilters>): void {
                                setFilters({ ...filters, ...newFilters, page: 0 })
                            }}
                            filters={filters}
                            isInTargetList={true} />
                        <TargetCompaniesList
                            section="target-bin"
                            templates={templates}
                            isLoadingEmailsHistory={isLoadingEmailsHistory}
                            emailsHistory={emailsHistory}
                            project={project}
                            targetList={targetList}
                            counters={counters}
                            contacts={contacts}
                            selectedIds={selectedIds}
                            setSelectedIds={arg => setSelectedIds(arg)}
                            setShowPopup={arg => setShowPopup(arg)}
                            showPopup={showPopup}
                            filters={filters}
                            setFilters={function (action: Partial<FindAllContactsFilters>): void {
                                setFilters(action);
                            }}
                            setPage={function (action: number): void {
                                setPage(action);
                            }}
                            resetFilters={function (): void {
                                resetFilters()
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}